import RuleExplanation from "@imminently/decisively-ui/AttributeExplanation";
import { GraphNode } from "@packages/commons";

/** A basic wrapper which auto provides the required contexts */
export const AttributeExplanation = ({ node }: { node: GraphNode }) => {
  return (
    <RuleExplanation node={node} />
  );
};